module.exports = __webpack_public_path__ + "img/close.e5955530.png";